import React, {useState} from 'react';
import {bool, object} from 'prop-types';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import classes from './CreateEntityMenu.module.css';

const CreateEntityMenu = ({
    companyInfo,
    hidden,
    history,
    onCreateArea,
    onCreateCampus,
    onCreateClient,
    onCreateEquipment,
    onCreateSite,
    onCreateSystem
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    if (hidden) {
        return null;
    }

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleCreateClientModal() {
        onCreateClient(true);
        handleClose();
    }

    function handleCreateAreaModal() {
        onCreateArea(true);
        handleClose();
    }

    function handleCreateCampusModal() {
        onCreateCampus(true);
        handleClose();
    }

    function handleCreateSiteModal() {
        onCreateSite(true);
        handleClose();
    }

    function handleCreateEquipmentModal() {
        onCreateEquipment(true);
        handleClose();
    }

    function handleCreateSystemModal() {
        onCreateSystem(true);
        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <img alt="" className={classes.icon} src="/assets/images/actionBarItem-add.svg" />
                New Entity
            </Button>

            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem onClick={handleCreateClientModal}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/clientTreeIcon.svg"
                    />
                    Client
                </MenuItem>
                <MenuItem onClick={handleCreateCampusModal}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/campusTreeIcon.svg"
                    />
                    Campus
                </MenuItem>
                <MenuItem onClick={handleCreateSiteModal}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/siteTreeIcon.svg"
                    />
                    Site
                </MenuItem>
                <MenuItem onClick={handleCreateSystemModal}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/systemTreeIcon.svg"
                    />
                    System
                </MenuItem>
                <MenuItem onClick={handleCreateAreaModal}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/areaTreeIcon.svg"
                    />
                    Area
                </MenuItem>
                <MenuItem onClick={handleCreateEquipmentModal}>
                    <img
                        alt=""
                        className={classes.contextIcon}
                        src="/assets/images/equipmentTreeIcon.svg"
                    />
                    Equipment
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

CreateEntityMenu.defaultProps = {
    hidden: false
};

CreateEntityMenu.propTypes = {
    companyInfo: object,
    hidden:      bool,
    history:     object
};

export default CreateEntityMenu;
